import { SharedService } from './../../../../services/shared.service';
import { Component } from '@angular/core';

@Component({
    selector: 'app-popup-menu',
    templateUrl: './popup-menu.component.html',
    styleUrls: ['./popup-menu.component.scss']
})
export class PopupMenuComponent {

    constructor(
        public sharedService: SharedService
    ) { }

    closeSideNav() {
        if (window.innerWidth < 768) {
            this.sharedService.sideNav.close();
        }
    }
}
